import React from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

import * as Types from '../types';
import * as helpers from '../helpers';
import { ISO_DATE_FORMAT } from '../constants';

export const withFieldProps =
<FieldValue, P extends object>(Wrapped: React.ComponentType<P>) =>
    (props: P & Types.TFinalFormFieldProps<FieldValue>) => {

    const dateFormat = useAppSelector(prop('dateFormat'));

    return (
        <Wrapped
            parse={(value: string) => helpers.convertInputDate({ value, fromFormat: dateFormat, toFormat: ISO_DATE_FORMAT })}
            format={(value: string) => helpers.convertInputDate({ value, toFormat: dateFormat, fromFormat: ISO_DATE_FORMAT })}
            {...props}
        />
    );
};
